import { modalService } from '../../services/ModalService.js'
import i18n from "../../language.js";

export function addSchool({ commit, dispatch, state }, payload){
      
      var school=payload.school;
      
      
      // test if already present == loosely
      var hasSchool= state.user_schools.find(school => (
        school.url === payload.school.url &&
        school.username === payload.school.username &&
        school.password === payload.school.password
        ))
      if(hasSchool){
        modalService.createAlert(i18n.t("language.user_already_present")).then(
          () => {
          }
        )
        return Promise.reject();
      }

      // login for school but no redirect
      return dispatch('login', { school } ).then(
      result=>{ 
        commit('ADD_SCHOOL', school);
        commit('SET_ACTIVE_SCHOOL', school);
        return result;
      },
      // error
      (error)=>{
        
        //console.log("error loggin in school")
        return Promise.reject(error);
      }
      )

 

    }